export class Faq{
  id: number;
  titulo: string;
  subtitulo: string;
  texto: string;
  tipo: number;
}
